/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import Alert from 'react-s-alert';
import moment from 'moment';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import { convertToTitleCase } from '../../../../helper';
// import { IconSearch } from 'modules/common/components/Icons';
import * as actions from '../actions';
import * as c from '../constant';
import ViewUploadModal from '../modals/ViewUploadModal';

import CmsContext from '../../../../context/CmsContext';

const BTAXBilling = ({
  getList,
  list,
  isLoading,
  pager,
  getUploadedList,
  uploadList,
  isLoadingUpload,
  pagerUpload,
  deleteFileUpload,
  deleteFileHistoryUpload,
  permissions,
}) => {
  const [formData, setFormData] = useState({
    is_active: 1,
    overwrite_previous: 0,
  });

  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const setModal = useContext(ModalContext);

  const [viewUploadHistory, setViewUploadHistory] = useState(false);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const handleChangePage = (page) => {
    getList({ ...formData, page });
  };

  const handleChangePageUpload = (page) => {
    getUploadedList({ ...formData, page });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  // const onUpload = (e) => {
  //   e.preventDefault();

  //   const data = new FormData();
  //   data.append('file', e.target.files[0]);
  //   data.append(
  //     'overwrite_previous',
  //     _.get(formData, 'overwrite_previous') ? 1 : 0
  //   );
  //   upload(data, () => {
  //     getList({ is_active: 1 });
  //   });
  // };

  useEffect(() => {
    getList({ is_active: 1 });
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    getList(formData);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      bin: '',
      period: '',
      is_active: 1,
    });
    getList({
      is_active: 1,
      overwrite_previous: 0,
    });
  };

  const formatPeriod = (data) => {
    return data
      ? data
          .replace('-1', ' - 1st quarter')
          .replace('-2', ' - 2nd quarter')
          .replace('-3', ' - 3rd quarter')
          .replace('-4', ' - 4th quarter')
      : '---';
  };

  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });
  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append(
        'overwrite_previous',
        _.get(formData, 'overwrite_previous') ? 1 : 0
      );
      data.append('is_delinquent', _.get(formData, 'is_delinquent') ? 1 : 0);
      const res = await postFormData(
        `${process.env.REACT_APP_WS}api/v1/administrators/btax_billing_csv_imports/upload_csv`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        setViewUploadHistory(true);
        getUploadedList({ subject: 'BTAX' });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  const handleOnViewFailedUploads = (e) => {
    e.preventDefault();
    setViewUploadHistory(true);
    getUploadedList({ subject: 'BTAX' });
  };

  const handleOnAllTransactions = (e) => {
    e.preventDefault();
    setViewUploadHistory(false);
    getList({ is_active: 1 });
  };

  const handleViewFailedRows = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Failed Uploaded Files',
      isOpen: true,
      content: <ViewUploadModal dataInfo={dataInfo} />,
      modalSize: 'modal-xxl',
    });
  };

  const handleDeleteButtonClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.bin') || 'this item'
      }?`,
      () => {
        deleteFileUpload(data.id, () => {
          getList({ is_active: 1 });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDeleteFileClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.file_name') || 'this item'
      }?`,
      () => {
        deleteFileHistoryUpload(data.id, () => {
          getUploadedList({ subject: 'BTAX' });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleAddModal = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <AddRecordModalV2 type="ADD" />,
      title: 'Add New Record',
      modalSize: 'modal-xxl',
      modalContentSize: 'custom-size'
    });
  };

  const paymentStatusBadge = status => {

    if (status === 'PENDING') return (<span className='bg-warning px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status === 'PAID') return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status.includes('QUARTER')) return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    
    return '---'
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-2 my-3 pl-2">
        <h2 className="mt-1 header-title font-weight-bold text-dark">
          Business Tax Billing
        </h2>
        <div className="d-flex">
          <div className="row-nav-end">
            {!viewUploadHistory && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleOnViewFailedUploads}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                  style={{ height: '42.98px' }}
                >
                  Upload History
                </button>
              </div>
            )}
            {viewUploadHistory && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleOnAllTransactions}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                  style={{ height: '42.98px' }}
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="p-4 billing-container">
        {!viewUploadHistory && (
          <form
            className="form-billing-container px-4 pt-4 d-flex justify-content-between"
            onSubmit={onSearch}
          >
            <div className="form-search-container d-flex flex-row">
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">BIN</label>
                <input
                  className="form-control-billing-bin text-dark"
                  name="bin"
                  onChange={onChange}
                  value={_.get(formData, 'bin')}
                />
              </div>
              {/* <div className="d-flex flex-column">
                <label className="label-title mb-2">PIN</label>
                <input
                  className="form-control-billing"
                  name="pin"
                  onChange={onChange}
                  value={_.get(formData, 'pin')}
                />
              </div> */}
              <div className="search-div d-flex align-items-start ml-2 pt-4">
                <button
                  type="submit"
                  className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                >
                  <div className="form-control-icon d-flex">
                    <span className="icon">
                      <i className="fa fa-lg fa-search" />
                    </span>
                    <span className="title-icon">Search</span>
                  </div>
                </button>
                <button
                  onClick={onClear}
                  type="button"
                  className="btn btn-link button-clear cms-bg-color-primary cms-outline-primary ml-2"
                >
                  <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                </button>
              </div>
            </div>

            <div className="form-upload-container flex-column">
              <div className="d-flex" style={{ width: '350px' }}>
                <div className="div-upload">
                  <label className="text-color-title mb-0">Upload Items</label>
                </div>
                <div className="d-flex flex-row flex-fill justify-content-end">
                  <div className="mr-2">
                    <input
                      name="overwrite_previous"
                      type="checkbox"
                      className="check-box"
                      checked={_.get(formData, 'overwrite_previous')}
                      onChange={onChange}
                    />
                  </div>
                  <label className="overwrite-label mb-0">Overwrite</label>
                </div>
                <div className="d-flex flex-row flex-fill justify-content-end">
                  <div className="mr-2">
                    <input
                      name="is_delinquent"
                      type="checkbox"
                      className="check-box"
                      checked={_.get(formData, 'is_delinquent')}
                      onChange={onChange}
                    />
                  </div>
                  <label className="overwrite-label mb-0">Delinquent</label>
                </div>
              </div>

              <div className="form-group mt-1 d-flex">
                {isLoading && (
                  <i className="fa fa-spin fa-spinner my-auto mr-2" />
                )}
                <input
                  type="file"
                  className="btn btn-link input-upload w-100"
                  onChange={fileHandler}
                />
                {/* {!isLoading && (
                  <input
                    type="file"
                    className="btn btn-link input-upload w-100"
                    onChange={fileHandler}
                  />
                )} */}
                <button
                  type="button"
                  onClick={onUploadFile}
                  className="ml-2 btn btn-link button-upload cms-bg-color-primary cms-outline-primary"
                >
                  Upload
                </button>
              </div>
              <p className="override-p">
                Note: Overriding makes the upload replace the current active
                items.{' '}
              </p>
            </div>
          </form>
        )}
        {!viewUploadHistory ? (
          <>
            <div className="card table-billing-containe">
              <div className="card-body">
                {isLoading ? (
                  <div
                    className="loading d-flex text-center justify-content-center align-items-center"
                    style={{ height: '500px' }}
                  >
                    <div className="spinner text-center ">
                      <span className="fas fa-5x fa-spin fa-spinner" />
                    </div>
                  </div>
                ) : (
                  <div className="table-scroll">
                    <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                      <thead className="table-header">
                        <tr className="billing-table-tr">
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Processed
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Expiration
                          </th>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            BIN
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Amount
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Payment From
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Payment To
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Account Name
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Account Number
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Delinquent
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Status
                          </th>
                          {Acl(permissions, ['BTAX BILLINGS ALLOW DELETE']) && (
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {list.map((item) => {
                          return (
                            <tr
                              className="billing-table-tr"
                              key={_.get(item, 'id')}
                            >
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.date_processed')
                                  ? moment(
                                      `${_.get(
                                        item,
                                        'attributes.date_processed'
                                      )}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.expiration_date')
                                  ? moment(
                                      `${_.get(
                                        item,
                                        'attributes.expiration_date'
                                      )}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.bin') || '---'}
                              </td>
                              <td className="py-3 align-middle">
                                <b>PHP</b>&nbsp;
                                {_.get(item, 'attributes.amount')
                                  ? parseFloat(
                                      _.get(item, 'attributes.amount')
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : '0.00'}
                              </td>
                              <td className="py-3 align-middle">
                                {formatPeriod(
                                  _.get(item, 'attributes.mode_of_payment_1')
                                )}
                              </td>
                              <td className="py-3 align-middle">
                                {formatPeriod(
                                  _.get(item, 'attributes.mode_of_payment_2')
                                )}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.account_name') ||
                                  '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.account_number') ||
                                  '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {+_.get(item, 'attributes.is_delinquent')
                                  ? 'YES'
                                  : 'NO'}
                              </td>
                              <td className="py-3 align-middle">
                                {paymentStatusBadge(_.get(item, 'attributes.payment_status'))}
                              </td>
                              {Acl(permissions, [
                                'BTAX BILLINGS ALLOW DELETE',
                              ]) && (
                                <td
                                  className="p-3 align-middle"
                                  style={{ width: '124px' }}
                                >
                                  <button
                                    type="button"
                                    className="btn-blank"
                                    onClick={handleDeleteButtonClicked(item)}
                                  >
                                    <i className="far fa-trash-alt icon-delete" />
                                  </button>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="list-pagination">
                  {pager.total_pages > 1 ? (
                    <div className="d-flex justify-content-center text-center align-item-center">
                      <Pagination data={pager} onChange={handleChangePage} />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* upload */}
            <div className="card">
              <div className="card-body">
                {isLoadingUpload ? (
                  <div
                    className="loading d-flex text-center justify-content-center align-items-center"
                    style={{ height: '500px' }}
                  >
                    <div className="spinner text-center ">
                      <span className="fas fa-5x fa-spin fa-spinner" />
                    </div>
                  </div>
                ) : (
                  <div className="table-scroll">
                    <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                      <thead className="table-header">
                        <tr className="billing-table-tr">
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            FILE NAME
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            DATE IMPORTED
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            FAILED ROWS
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            TOTAL ROWS
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            STATUS
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            ACTION
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {uploadList.map((item) => {
                          return (
                            <tr
                              className="billing-table-tr"
                              key={_.get(item, 'id')}
                            >
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.file_namename') ||
                                  '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.date_imported')
                                  ? moment(
                                      `${_.get(
                                        item,
                                        'attributes.date_imported'
                                      )}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.failed_rows') || '0'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.total_rows')}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.status')}
                              </td>
                              <td className="p-3 align-middle">
                                {_.get(item, 'attributes.failed_rows') > 0 ? (
                                  <>
                                    {Acl(permissions, [
                                      'BTAX BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                        style={{ heigh: '70px' }}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      onClick={handleViewFailedRows(item)}
                                      className="btn-blank"
                                      style={{ heigh: '70px' }}
                                    >
                                      <i className="far fa-eye icon-view" />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {Acl(permissions, [
                                      'BTAX BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="list-pagination">
                  {pagerUpload.total_pages > 1 ? (
                    <div className="d-flex justify-content-center text-center align-item-center">
                      <Pagination
                        data={pagerUpload}
                        onChange={handleChangePageUpload}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

BTAXBilling.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingUpload: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  pagerUpload: PropTypes.instanceOf(Object).isRequired,
  getUploadedList: PropTypes.instanceOf(Function).isRequired,
  uploadList: PropTypes.instanceOf(Array).isRequired,
  deleteFileUpload: PropTypes.instanceOf(Function).isRequired,
  deleteFileHistoryUpload: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  list: _.get(api, `${c.LIST}.list`) || [],
  uploadList: _.get(api, `${c.UPLOAD_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  isLoadingUpload: _.get(api, 'loading', []).indexOf(c.UPLOAD_LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
  pagerUpload: _.get(api, `${c.UPLOAD_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BTAXBilling);
